/**
 * Wiederverwendbare Komponente für Preisanzeige
 * Unterstützt optionales Loading, Formatierung und Styling
 */
export default function PriceDisplay({
  price,
  isLoading = false,
  size = "base", // xs, sm, base, lg
  color = "slate", // slate, orange
  format = (p) => `${p}€`, // Formatierungsfunktion
  loadingText = "Laden...",
}) {
  const sizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
  };

  const colorClasses = {
    slate: "text-slate-600",
    orange: "text-[#FF5744]",
  };

  const fontClasses = color === "orange" ? "font-bold" : "font-semibold";

  return (
    <div
      className={`${sizeClasses[size]} ${colorClasses[color]} ${fontClasses}`}
    >
      {isLoading ? loadingText : `ab ${format(price)}`}
    </div>
  );
}
